import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import '@mantine/core/styles.css';
import '@/styles/mantine-overrides.sass';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import { AuthProvider, Routes, showError } from '@/shared';
import { theme } from '@/styles/theme';
import { cognitoUserManager } from '@/config/authConfig';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => showError(error),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const handleSigninCallback = (): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

const App = () => {
  return (
    <OidcAuthProvider userManager={cognitoUserManager} onSigninCallback={handleSigninCallback}>
      <QueryClientProvider client={queryClient}>
        <MantineProvider theme={theme}>
          <ModalsProvider>
            <Notifications />
            <AuthProvider>
              <Routes />
            </AuthProvider>
          </ModalsProvider>
        </MantineProvider>
      </QueryClientProvider>
    </OidcAuthProvider>
  );
};

export default App;
